import type { Id } from "@convex/_generated/dataModel";
import { isUnknownRecord } from "@shared/validation/narrow";

function isStorageIdResponse(
  body: unknown,
): body is { storageId: Id<"_storage"> } {
  return isUnknownRecord(body) && typeof body.storageId === "string";
}

export async function uploadToStorage(
  uploadUrl: string,
  file: File,
): Promise<Id<"_storage">> {
  const response = await fetch(uploadUrl, {
    method: "POST",
    headers: { "Content-Type": file.type || "application/octet-stream" },
    body: file,
  });
  if (!response.ok) throw new Error("Upload failed");
  const body: unknown = await response.json();
  if (!isStorageIdResponse(body)) {
    throw new Error("Upload completed without a storage ID");
  }
  return body.storageId;
}
